module.exports = __webpack_public_path__ + "img/2.58bd749c.jpg";